import { CtaButtonFragment } from "~/components/modules/CtaButton/graphql";
import { downloadSectionFileFragment } from "~/components/modules/DownloadSectionFile/graphql";
import { externalEmbedFragment } from "~/components/modules/ExternalEmbed/graphql";
import { galleryGridFragment } from "~/components/modules/GalleryGrid/graphql";
import { LpCardBlockFragment } from "~/components/modules/LpCardBlock/graphql";
import { publicationTeaserFragment } from "~/components/modules/PublicationTeaser/graphql";
import { ResponsiveBannerFragment } from "~/components/modules/ResponsiveBanner/graphql";
import { responsiveImageFragment } from "~/components/modules/ResponsiveImage/graphql";
import { singleImageFragment } from "~/components/modules/SingleImage/graphql";
import { SpeakerblockFragment } from "~/components/modules/SpeakerBlock/graphql";
import { VideoListFragment } from "~/components/modules/VideoListBlock/graphql";
import { graphql } from "~/lib/graphql";

export const LpAccordionFragment = graphql(
  `
    fragment LpAccordionFragment on LpAccordionRecord {
      __typename
      id
      lpAccordionItems {
        id
        title
        slug
        stickyTitle
        icon {
          id
          url
          format
          width
          height
          alt
        }
        content {
          value
        }
        modularContent {
          __typename
          ... on ImageSingleRecord {
            __typename
            id
            ...singleImageFragment
          }
          ... on ResponsiveImageRecord {
            __typename
            id
            ...responsiveImageFragment
          }
          ... on ExternalEmbedRecord {
            __typename
            id
            ...externalEmbedFragment
          }
          ... on SpeakerblockRecord {
            __typename
            id
            ...SpeakerblockFragment
          }
          ... on VideoListRecord {
            __typename
            id
            ...VideoListFragment
          }
          ... on PublicationTeaserRecord {
            __typename
            id
            ...publicationTeaserFragment
          }
          ... on GalleryGridRecord {
            __typename
            id
            ...galleryGridFragment
          }
          ... on DownloadSectionFileRecord {
            __typename
            id
            ...downloadSectionFileFragment
          }
          ... on ResponsiveBannerRecord {
            __typename
            id
            ...ResponsiveBannerFragment
          }
          ... on LpCardBlockRecord {
            __typename
            id
            ...LpCardBlockFragment
          }
          ... on CtaButtonRecord {
            id
            __typename
            ...CtaButtonFragment
          }

          # Fallback for any other record types
          ... on RecordInterface {
            __typename
            id
          }
        }
      }
    }
  `,
  [
    singleImageFragment,
    responsiveImageFragment,
    externalEmbedFragment,
    VideoListFragment,
    SpeakerblockFragment,
    publicationTeaserFragment,
    galleryGridFragment,
    downloadSectionFileFragment,
    ResponsiveBannerFragment,
    LpCardBlockFragment,
    CtaButtonFragment,
  ],
);
